import styled from 'styled-components';

export const InputFieldsBox = styled.div`
  width: 100%;
`;

export const PuzzleDetailsBox = styled.div`
  margin-top: 20px;
`;

export const PuzzleDetailsName = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
`;

export const PuzzleDetailsImage = styled.img`
  width: 100px;
  text-align: center;
  cursor: pointer;
`;
